import React, { ReactNode } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface Props {
  isVisible: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
  message: string | ReactNode;
  title: string | ReactNode;
  closeButtonText?: string;
  confirmButtonText?: string;
}

const ConfirmationDialog: React.FC<Props> = (props: Props) => {
  return (
    <Dialog open={props.isVisible} onClose={props.onClose}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button fullWidth color="error" variant="contained" onClick={props.onClose}>
          {props.closeButtonText || 'Stäng'}
        </Button>
        <Button fullWidth color="primary" variant="contained" onClick={props.onConfirm}>
          {props.confirmButtonText || 'Ok'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
